(function () {
  // Botones + / − de cantidad
  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-step]');
    if (!step) return;
    var input = step.closest('[data-qty]').querySelector('input');
    var next = (parseInt(input.value, 10) || 1) + parseInt(step.dataset.step, 10);
    input.value = Math.max(1, next);
  });

  // Packs: el botón muestra el total del pack elegido
  document.addEventListener('change', function (event) {
    var radio = event.target.closest('[data-packs] input[type=radio]');
    if (!radio) return;
    var total = radio.form && radio.form.querySelector('[data-pack-total]');
    if (total) total.textContent = radio.dataset.total;
  });

  // Temporizador global: cuenta regresiva real hasta data-end; se oculta al terminar
  document.querySelectorAll('[data-countdown]').forEach(function (bar) {
    var end = Date.parse(bar.dataset.end);
    if (!isFinite(end)) return;
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var left = end - Date.now();
      if (left <= 0) { bar.hidden = true; clearInterval(timer); return; }
      var s = Math.floor(left / 1000);
      bar.querySelector('[data-d]').textContent = pad(Math.floor(s / 86400));
      bar.querySelector('[data-h]').textContent = pad(Math.floor(s / 3600) % 24);
      bar.querySelector('[data-m]').textContent = pad(Math.floor(s / 60) % 60);
      bar.querySelector('[data-s]').textContent = pad(s % 60);
      bar.hidden = false;
    };
    var timer = setInterval(tick, 1000);
    tick();
  });

  // Fecha estimada de entrega en días hábiles (lunes a viernes)
  document.querySelectorAll('[data-delivery]').forEach(function (el) {
    var addBusinessDays = function (date, days) {
      var d = new Date(date);
      while (days > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) days--; }
      return d;
    };
    var fmt = new Intl.DateTimeFormat('es-CL', { weekday: 'long', day: 'numeric', month: 'long' });
    var now = new Date();
    var from = addBusinessDays(now, parseInt(el.dataset.min, 10) || 1);
    var to = addBusinessDays(now, parseInt(el.dataset.max, 10) || 3);
    el.querySelector('[data-delivery-range]').textContent = 'entre el ' + fmt.format(from) + ' y el ' + fmt.format(to);
  });

  // Galería de producto
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.dataset.src;
        main.srcset = '';
        main.alt = thumb.dataset.alt || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      });
    });
  });

  // Calculadora de ahorro
  document.querySelectorAll('[data-calc]').forEach(function (calc) {
    var range = calc.querySelector('input[type=range]');
    var washPrice = parseInt(calc.dataset.washPrice, 10) || 0;
    var productPrice = parseInt(calc.dataset.productPrice, 10) || 0;
    var fmt = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 });
    function render() {
      var perMonth = parseInt(range.value, 10);
      var yearly = perMonth * 12 * washPrice;
      var payback = washPrice > 0 ? Math.ceil(productPrice / washPrice) : 0;
      calc.querySelector('[data-calc-count]').textContent = perMonth;
      calc.querySelector('[data-calc-yearly]').textContent = fmt.format(yearly);
      calc.querySelector('[data-calc-payback]').textContent = payback > 0 ? payback + ' lavados' : '—';
    }
    range.addEventListener('input', render);
    render();
  });

  // Barra fija de compra: aparece cuando el botón principal sale de la pantalla
  var bar = document.querySelector('[data-sticky-buy]');
  var target = document.querySelector('[data-buy-now]');
  if (bar && target && 'IntersectionObserver' in window) {
    var btn = bar.querySelector('button');
    btn.addEventListener('click', function () { target.click(); });
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
    }).observe(target);
  }
})();
